import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useMctestInfo() {
  return useQuery({
    queryKey: ["mctest-info"],
    queryFn: () => api.getMctestInfo(),
    // Branch listing is an SSM + registry round trip; no need to redo it per render.
    staleTime: 60_000,
  });
}

export function useTriggerMctest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ mooncakeRef, startAt }: { mooncakeRef: string; startAt: string | null }) =>
      api.triggerMctest(mooncakeRef, startAt),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ["ci-jobs-overview"] }),
  });
}
